var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavHeader'),_c('div',{staticClass:"bodyClass"},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }